import { combineReducers } from "redux";
import registerReducer from "./registerReducer";
import loginReducer from "./loginReducer";
import phoneCheckReducer from "./phoneCheckReducer";
import MainCourseReducer from "./mainCourseReducer";
import JuiceReducer from "./JuiceReducer";
import SelectedMealReducer from "./selectedCourse";
import SlideReducer from "./SlideReducer";
const rootReducer = combineReducers({
  registerReducer,
  loginReducer,
  phoneCheckReducer,
  MainCourseReducer,
  JuiceReducer,
  SelectedMealReducer,
  SlideReducer,
});

export default rootReducer;
